import http from "../http";

// Provinces
export const fetchProvinces = () => http.get("/core-basics/provinces/");
export const createProvince = (data) =>
  http.post("/core-basics/provinces/", data);
export const updateProvince = (id, data) =>
  http.put(`/core-basics/provinces/${id}/`, data);
export const deleteProvince = (id) =>
  http.delete(`/core-basics/provinces/${id}/`);

// Cities
export const fetchCities = () => http.get("/core-basics/cities/");
export const createCity = (data) => http.post("/core-basics/cities/", data);
export const updateCity = (id, data) =>
  http.put(`/core-basics/cities/${id}/`, data);
export const deleteCity = (id) => http.delete(`/core-basics/cities/${id}/`);

// Store Types
export const fetchStoreTypes = () => http.get("/core-basics/store-types/");
export const createStoreType = (data) =>
  http.post("/core-basics/store-types/", data);
export const updateStoreType = (id, data) =>
  http.put(`/core-basics/store-types/${id}/`, data);
export const deleteStoreType = (id) =>
  http.delete(`/core-basics/store-types/${id}/`);

// Plans
export const fetchPlans = () => http.get("/core-basics/plans/");
export const createPlan = (data) => http.post("/core-basics/plans/", data);
export const updatePlan = (id, data) =>
  http.put(`/core-basics/plans/${id}/`, data);
export const deletePlan = (id) => http.delete(`/core-basics/plans/${id}/`);

// Payment Gateways
export const fetchGateways = () => http.get("/core-basics/payment-gateways/");
export const createGateway = (data) =>
  http.post("/core-basics/payment-gateways/", data);
export const updateGateway = (id, data) =>
  http.put(`/core-basics/payment-gateways/${id}/`, data);
export const deleteGateway = (id) =>
  http.delete(`/core-basics/payment-gateways/${id}/`);

// Templates
export const fetchTemplates = () => http.get("/core-basics/templates/");
export const createTemplate = (data) =>
  http.post("/core-basics/templates/", data);
export const updateTemplate = (id, data) =>
  http.put(`/core-basics/templates/${id}/`, data);
export const deleteTemplate = (id) =>
  http.delete(`/core-basics/templates/${id}/`);

// Template Sections
export const fetchTemplateSections = () =>
  http.get("/core-basics/template-sections/");
export const createTemplateSection = (data) =>
  http.post("/core-basics/template-sections/", data);
export const updateTemplateSection = (id, data) =>
  http.put(`/core-basics/template-sections/${id}/`, data);
export const deleteTemplateSection = (id) =>
  http.delete(`/core-basics/template-sections/${id}/`);
